import { NgOptimizedImage } from '@angular/common';
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    signal,
    ViewChild,
    WritableSignal
} from '@angular/core';
import { IconComponent } from '../../../../icon/icon.component';
import { PillComponent } from '../../../../pill/pill.component';
import { TooltipComponent } from '../../../../tooltip/tooltip.component';
import { SanitizeHtmlPipe } from '../../../pipes/sanitize-html.pipe';
import { TintDirective } from '../../tint/tint.directive';
import { VideoComponent } from '../../video-block/components/video/video.component';
import { KeyTopicTwoBlockConfiguration } from '../models/key-topic-two.models';

@Component({
    selector: 'nw-key-topic-two',
    imports: [
        TintDirective,
        IconComponent,
        PillComponent,
        TooltipComponent,
        SanitizeHtmlPipe,
        NgOptimizedImage,
        VideoComponent
    ],
    templateUrl: './key-topic-two.component.html',
    styleUrl: './key-topic-two.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KeyTopicTwoComponent implements AfterViewInit {
    @Input() body?: string;
    @Input() media?: KeyTopicTwoBlockConfiguration.Media;
    @Input() author?: KeyTopicTwoBlockConfiguration.Author;
    @Input() logo?: KeyTopicTwoBlockConfiguration.Logo;
    @Input() step?: number;
    @Input() tooltip?: string;
    @Input() alignment?: KeyTopicTwoBlockConfiguration.Alignment;

    @ViewChild('navRef', { static: false }) navRef!: ElementRef;

    public hasNavigation$$: WritableSignal<boolean | undefined> = signal(undefined);

    public ngAfterViewInit(): void {
        this.hasNavigation$$.set(
            !!(this.navRef.nativeElement as HTMLElement)?.children[0]?.innerHTML?.trim()
        );
    }
}
